// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-tittle-box_ProjectTittleBox__1M17O {
    width: 100%;
    height: 20px;
    max-width: 67px;
    cursor: pointer;
    text-align: right;
    border-radius: 50px;
    vertical-align: top;
    display: inline-block;
    float: none !important;
    border: 1px solid #D6E5B8;
    transition: border-color 0.3s;
}
.project-tittle-box_ProjectTittleBox__1M17O.project-tittle-box_active__THWOF {
    border-color: #85995C !important;
}
.project-tittle-box_ProjectTittleBox__1M17O p {
    margin: 0%;
    font-size: 8px;
    margin-top: 5px;
    color: #FFFFFF;
    text-align: center;
}

@media (min-width: 1200px) {
    .project-tittle-box_ProjectTittleBox__1M17O {
        width: 100%;
        margin: 10px;
        height: 50px;
        max-width: 200px;
        border-radius: 100px;
        border: 3px solid #D6E5B8;
    }
    .project-tittle-box_ProjectTittleBox__1M17O p {
        margin: 0%;
        font-size: 25px;
        margin-top: 9px;
        color: #FFFFFF;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/project-tittle-box/project-tittle-box.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,oBAAoB;QACpB,yBAAyB;IAC7B;IACA;QACI,UAAU;QACV,eAAe;QACf,eAAe;QACf,cAAc;IAClB;AACJ","sourcesContent":[".ProjectTittleBox {\r\n    width: 100%;\r\n    height: 20px;\r\n    max-width: 67px;\r\n    cursor: pointer;\r\n    text-align: right;\r\n    border-radius: 50px;\r\n    vertical-align: top;\r\n    display: inline-block;\r\n    float: none !important;\r\n    border: 1px solid #D6E5B8;\r\n    transition: border-color 0.3s;\r\n}\r\n.ProjectTittleBox.active {\r\n    border-color: #85995C !important;\r\n}\r\n.ProjectTittleBox p {\r\n    margin: 0%;\r\n    font-size: 8px;\r\n    margin-top: 5px;\r\n    color: #FFFFFF;\r\n    text-align: center;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .ProjectTittleBox {\r\n        width: 100%;\r\n        margin: 10px;\r\n        height: 50px;\r\n        max-width: 200px;\r\n        border-radius: 100px;\r\n        border: 3px solid #D6E5B8;\r\n    }\r\n    .ProjectTittleBox p {\r\n        margin: 0%;\r\n        font-size: 25px;\r\n        margin-top: 9px;\r\n        color: #FFFFFF;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProjectTittleBox": `project-tittle-box_ProjectTittleBox__1M17O`,
	"active": `project-tittle-box_active__THWOF`
};
export default ___CSS_LOADER_EXPORT___;
